import { WarningIcon } from "../../icons";
import {
  deleteModalBody,
  deleteModalHeader,
  deleteModalBodyParagraph,
} from "../../util/constants";
import { Button } from "../CommonUIComponents/Button/Button";
import { Modal } from "../CommonUIComponents/Modal/Modal";
import "./ViewEngagementDeleteModal.scss";

function ModalBody() {
  return (
    <>
    <div className="view-endagement-delete-modal-paragraph"> {deleteModalBodyParagraph}</div>
    <span className="view-endagement-delete-modal-body">{deleteModalBody}</span>
    </>
  );
}

function ModalFooter({ handleCancelClick, onConfirm }) {
  return (
    <div className="view-endagement-delete-modal-footer">
      <Button onClick={onConfirm} variant="primary">
        {"Yes, close"}
      </Button>
    </div>
  );
}

export function ViewEngagementDeleteModal({
  isModalVisible,
  onClose,
  onConfirm,
}) {
  return (
    <Modal
      show={isModalVisible}
      onClose={onClose}
      header={
        <div className="file-version-history-modal-header">
          <div className="motif-fab">
            <WarningIcon />
          </div>
          <span>{deleteModalHeader}</span>
        </div>
      }
      body={<ModalBody />}
      footer={<ModalFooter handleCancelClick={onClose} onConfirm={onConfirm} />}
    />
  );
}
